/** Helpers for the client organization sidebar. */
function searchable(text) {
    return text
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
}
/** Organizations whose name or identifier contains every word of `query`,
 * ignoring case and accents, in their original order. */
export function filterOrganizations(orgs, query) {
    const words = searchable(query).split(/\s+/).filter(Boolean);
    if (words.length === 0)
        return orgs;
    return orgs.filter(org => {
        const haystack = `${searchable(org.name)} ${searchable(org.slug)}`;
        return words.every(word => haystack.includes(word));
    });
}
/** One or two letters for the collapsed sidebar: "Acme Holdings" → "AH". */
export function initials(name) {
    const words = name
        .split(/[\s\-_.,&]+/)
        .map(w => w.replace(/[^\p{L}\p{N}]/gu, ''))
        .filter(Boolean);
    if (words.length === 0)
        return '?';
    const letters = words.length === 1 ? words[0].slice(0, 2) : words[0][0] + words[1][0];
    return letters.toUpperCase();
}
